export const pageSettings = (pageSize = 10) => ({
  pageSize,
  current: 1,
  hideOnSinglePage: true,
  showTitle: false,
  total: 0,
  pages: 0,
});
